import React, { useEffect, useRef, useState } from 'react';
import { Linkedin } from 'lucide-react';
import { team } from '../mock';

const Team = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Trigger the slide-in animation as soon as the section enters the viewport.
  useEffect(() => {
    if (!sectionRef.current) return;
    const node = sectionRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="equipe"
      ref={sectionRef}
      className="py-24 px-6 bg-[#fafafa] overflow-hidden"
    >
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-16">
          <p
            className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            EQUIPE
          </p>
          <h2
            className="text-[#1a1a1a] text-[36px] md:text-[44px] font-bold tracking-tight"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Núcleo de Gestão
          </h2>
          <div className="mx-auto mt-4 w-24 h-[3px] bg-[#C99A36]" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {team.map((member, idx) => (
            <div
              key={member.id}
              className="flex flex-col items-center text-center group"
            >
              {/* Photo with slide-in animation from the left */}
              <div className="w-full max-w-[260px] h-[300px] mb-5 overflow-visible">
                <img
                  src={member.photo}
                  alt={member.name}
                  draggable={false}
                  className="w-full h-full object-contain transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04]"
                  style={{
                    transform: visible ? 'translateX(0)' : 'translateX(-120%)',
                    opacity: visible ? 1 : 0,
                    transitionProperty: 'transform, opacity',
                    transitionDuration: '1100ms, 700ms',
                    transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1), ease-out',
                    transitionDelay: `${idx * 220}ms, ${idx * 220}ms`,
                  }}
                />
              </div>

              <h3
                className="text-[#1a1a1a] text-[15px] font-bold tracking-[0.06em] uppercase mb-3 px-2"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {member.name}
              </h3>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#888] hover:text-[#C99A36] transition-colors mb-3"
                aria-label={`LinkedIn de ${member.name}`}
              >
                <Linkedin size={22} strokeWidth={1.5} />
              </a>
              <p
                className="text-[#555] text-[13px] tracking-wide"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                {member.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
